import React, {
  useReducer,
  useState,
  useEffect,
} from 'react';
import FormFilter from './components/filter';
import {
  Container,
  Button,
} from './styles';
import { T2 } from '../../../styles/titles';
import {
  PainelVendasFilterProps,
} from '../../../global/dataTransferObjects/transacoesTempoReal';
import LiveTable from './components/liveTable';
import LoadingOverlay from '../../../components/LoadingOverlay';
import ZeroState from '../../../components/ZeroState';
import { formatDate } from '../../../utils/formatDate';
import { InitialState, Reducer } from '../painelDeRecebiveis/actions/reducer';
import PainelDePagamentosService from './service/PainelDePagamentosService';
import { getErrorMessage } from '../../../utils/getErrorMessage';
import { can, PortalPermissions } from "../../../config/permissions";

const painelDePagamentosService = new PainelDePagamentosService();

const PainelDePagamentos: React.FC = () => {
  const [state, dispatch] = useReducer(Reducer, InitialState);
  const [filterData, setFilterData] = useState<any>(null);
  const [pagamentos, setPagamentos] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [totals, setTotals] = useState({ totalGross: 0, totalLiquid: 0 });
  const [bulkFlags, setBulkFlags] = useState<{ pixPaid?: boolean; creditPaid?: boolean; debitPaid?: boolean }>({});

  let today: Date = new Date();
  today.setHours(0, 0, 0, 0);

  useEffect(() => {
    setTimeout(() => {
      handleFilter({
        initialDate: formatDate(today),
        finalDate: formatDate(today),
        tipoPagamento: '0',
        businessName: '',
        paid: false,
      });
    }, 200);
  }, []);

  const handleFilter = async (filter: any): Promise<void> => {
    setFilterData(filter);
  };

  const handleDownload = async (filter?: PainelVendasFilterProps) => {
    setLoading(true);
    try {
      await painelDePagamentosService.downloadPagamentos('xls', filter);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
      if (errorMessage === 'Request failed with status code 401') {
        window.location.assign(`${window.location.origin}/login`);
      }
    } finally {
      setLoading(false);
    }
  };

  if (state.zeroState) {
    return <ZeroState />;
  }

  return (
    <Container>
      <LoadingOverlay show={loading} relative />
      <T2>Painel De Pagamentos</T2>
      <FormFilter
        setLoading={setLoading}
        loading={loading}
        liveTransactions={pagamentos}
        externalLiveTransactions={pagamentos}
        onFormSubmit={handleFilter}
        filter={filterData}
        totalGross={totals.totalGross}
        totalLiquid={totals.totalLiquid}
        bulkFlags={bulkFlags}
      />
      {can(PortalPermissions.transacoes.pagamentos.exportar) && (
        <Button
          onClick={() => { handleDownload(filterData); }}
          style={{ marginBottom: '25px', marginRight: '24px', width: '150px', alignSelf: 'start' }}
        >
          Download Xlsx
        </Button>
      )}
      <LiveTable dataFilter={filterData} setPagamentos={setPagamentos} setTotals={setTotals} setBulkFlags={setBulkFlags} />
    </Container>
  );
};

export default PainelDePagamentos;
